/* eslint-disable no-restricted-globals */
export const width = screen.width;
export const height = screen.height;
export const availWidth = screen.availWidth;
export const availHeight = screen.availHeight;
export const popupWidth = 1200;
export const popupHeight = 600;
export const popupLeft = (width - popupWidth) / 2;
export const popupTop = (height - popupHeight) / 4;
